import { PairedDevice } from '@shure/cloud/shared/models/devices';

import { PairedDevicesFragment } from '../graphql/generated/cloud-sys-api';

import { mapDeviceModelFromSysApi } from './utils';

export function mapPairedDevicesFromSysApi(pairedDevices: PairedDevicesFragment['pairedDevices']): PairedDevice[] {
	return pairedDevices.map(({ device }) => ({
		id: device.id,
		model: mapDeviceModelFromSysApi(device.interface.model ?? ''),
		name: device.features.name?.name
	}));
}
